/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".m-t-15[_ngcontent-%COMP%]{margin-top:15px}.m-b-15[_ngcontent-%COMP%]{margin-bottom:15px}.m-l-10[_ngcontent-%COMP%]{margin-left:10px}.alert-danger[_ngcontent-%COMP%]{color:#a94442;background-color:#f2dede;border-color:#ebccd1;padding:15px;border-radius:4px}\n/*# sourceMappingURL=error.component.css.map*/"];
export { styles as styles };
